<template>
  <div>
    <div class="schedule-section white rounded-5">
      <div class="row">
        <!-- CALENDAR -->
        <div class="col-12 col-md-6 col-lg-6 calendar-popup d-none d-md-block">
          <CalendarPlugin
            :border="false"
            :create_new="false"
            nav_align="right"
          ></CalendarPlugin>
        </div>

        <!-- CALENDAR SCHEDULES -->
        <div class="col-12 col-md-6 col-lg-6">
          <div class="schedule-block">
            <!-- SCHEDULE HEADER -->
            <div
              class="d-flex justify-content-between align-items-center nowrap"
            >
              <div
                class="d-flex justify-content-start align-items-center nowrap"
              >
                <!-- AVATAR DATE -->
                <div class="avatar rounded-10 avatar_sm_md">
                  <div class="avatar-with-meta brand_inverse_light_bg">
                    <div class="avatar-title brand_navy font-14">
                      {{ getDay }}
                    </div>
                    <div class="avatar-meta color_ash font-10">
                      {{ getMonth }}
                    </div>
                  </div>
                </div>

                <!-- SCHEDULE DESCRIPTION -->
                <div class="schedule-info">
                  <div class="title font-weight-bold color_text">
                    Today’s Schedule
                  </div>
                  <div class="description color_grey_dark">
                    Lessons across all classes.
                  </div>
                </div>
              </div>

              <!-- CALENDAR ICON -->
              <div>
                <span
                  class="icon-calendar color_grey_dark font-20 mr-4 d-md-none"
                  @click="toggleCalendar"
                ></span>
              </div>
            </div>
          </div>

          <!-- SCHEDULE EVENTS -->
          <template v-if="schedules.length">
            <EventSchedule
              v-for="(schedule, index) in schedules"
              :key="index"
              :type="schedule.type"
              :class_name="schedule.class_name"
              :subject="schedule.subject_name"
              :time="schedule.time | convertTimeToTwelveHours"
            ></EventSchedule>
          </template>
          <template v-else>
            <div class="empty-container">
              <DefaultEventSchedule></DefaultEventSchedule>
              <DefaultEventSchedule></DefaultEventSchedule>
              <DefaultEventSchedule></DefaultEventSchedule>
              <DefaultEventSchedule></DefaultEventSchedule>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { twelveHoursTime } from "@/scripts/utilities";

export default {
  name: "Schedule",

  props: {
    teacher_id: Number,
  },

  components: {
    CalendarPlugin: () =>
      import(
        /* webpackChunkName: "calendar" */ "@/components/globalComps/CalendarComps/CalendarPlugin"
      ),
    EventSchedule: () =>
      import(
        /* webpackChunkName: "schedule" */ "@/components/profileComps/teacherprofile/EventSchedule"
      ),
    DefaultEventSchedule: () =>
      import(
        /* webpackChunkName: "schedule" */ "@/components/profileComps/teacherprofile/DefaultEventSchedule"
      ),
  },

  data() {
    return {
      date_obj: new Date(),
      schedules: [],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
    };
  },

  filters: {
    convertTimeToTwelveHours(value) {
      return twelveHoursTime(value);
    },
  },

  computed: {
    ...mapGetters(["getDateState"]),

    getDay() {
      return this.date_obj.getDate();
    },

    getMonth() {
      let month = this.date_obj.getMonth();
      return this.months[month].slice(0, 3);
    },
  },

  watch: {
    getDateState: {
      handler(newVal) {
        if (newVal) this.getTeacherSchedule();
      },
      immediate: true,
    },
  },

  mounted() {
    this.getTeacherSchedule();
  },

  methods: {
    ...mapActions(["getSingleTeacherCalender"]),

    toggleCalendar() {
      let calendar = document.querySelector(".calendar-popup");
      calendar.classList.toggle("d-none");
    },

    getTeacherSchedule() {
      let teacher_data = { id: this.teacher_id, date: this.getDateState };

      this.getSingleTeacherCalender(teacher_data)
        .then((response) => {
          if (response.data !== null && response.code === 200)
            this.schedules = response.data;
          else this.schedules = [];
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss">
.schedule-section {
  padding: 10px 0px;
  margin-bottom: 30px;

  @include breakpoint_max(sm) {
    padding: 5px 0px;
  }

  .schedule-block {
    margin-top: 25px;
    margin-bottom: 22px;

    @include breakpoint_max(md) {
      margin-left: 20px;
    }

    @include breakpoint_max(sm) {
      margin-top: 15px;
      margin-bottom: 15px;
    }

    .avatar {
      margin-right: 15px;
      @include breakpoint_max(sm) {
        margin-right: 10px;
        @include equal_min_edge(38);
      }
    }

    .title {
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 1px;

      @include breakpoint_max(sm) {
        font-size: 14px;
      }
    }

    .description {
      font-size: 12px;
      line-height: 16px;

      @include breakpoint_max(sm) {
        font-size: 11.5px;
      }
    }
  }
}
</style>
